import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console and update state
    console.error('Error boundary caught an error:', error, errorInfo);
    
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      const containerStyle = {
        padding: '40px',
        textAlign: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderRadius: '12px',
        margin: '20px auto',
        maxWidth: '600px',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
      };

      const headingStyle = {
        color: '#dc3545',
        marginBottom: '20px'
      };

      const buttonStyle = {
        padding: '10px 20px',
        background: 'linear-gradient(135deg, #3b82f6 0%, #1e3a8a 100%)',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '16px',
        marginTop: '20px',
        transition: 'all 0.3s ease',
        fontWeight: 'bold'
      };

      const detailsStyle = {
        textAlign: 'left',
        backgroundColor: '#f8f9fa',
        padding: '15px',
        borderRadius: '4px',
        marginTop: '20px',
        fontSize: '12px',
        color: '#6c757d',
        border: '1px solid #dee2e6'
      };

      return (
        <div style={containerStyle}>
          <h2 style={headingStyle}>⚠️ Something went wrong</h2>
          <p>
            We're sorry, but something unexpected happened. 
            Please try refreshing the page or contact support if the problem persists.
          </p>
          
          <button 
            style={buttonStyle}
            onClick={() => window.location.reload()}
          >
            Refresh Page
          </button>

          <button 
            style={{ ...buttonStyle, background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)', marginLeft: '10px' }}
            onClick={() => window.location.href = '/login'}
          >
            Back to Login
          </button>

          {process.env.NODE_ENV === 'development' && this.state.error && (
            <details style={detailsStyle}>
              <summary>Error Details (Development Only)</summary>
              <pre style={{ marginTop: '10px', whiteSpace: 'pre-wrap' }}>
                {this.state.error.toString()}
                {this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 